export default function FacebookIcon({ socialIconClass }) {
  return (
    <svg className={socialIconClass} viewBox='0 0 58.59 58.23'>
      <path
        fill='#fff'
        d='M58.59,29.29C58.59,13.12,45.47,0,29.29,0S0,13.12,0,29.29c0,14.62,10.71,26.74,24.72,28.94v-20.47h-7.44v-8.47h7.44v-6.45c0-7.34,4.37-11.4,11.06-11.4,3.2,0,6.56,.57,6.56,.57v7.21h-3.7c-3.64,0-4.77,2.26-4.77,4.58v5.5h8.12l-1.3,8.47h-6.83v20.47c14.01-2.2,24.72-14.31,24.72-28.94Z'
      />
    </svg>
  );
}
